import { render, staticRenderFns } from "./OptionNav.vue?vue&type=template&id=5bccff09&scoped=true&"
import script from "./OptionNav.vue?vue&type=script&lang=js&"
export * from "./OptionNav.vue?vue&type=script&lang=js&"
import style0 from "./OptionNav.vue?vue&type=style&index=0&id=5bccff09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bccff09",
  null
  
)

export default component.exports